import React from 'react'
import Icon from 'components/Icon'
import { Box, Flex } from 'components/Layout'
import Link from 'components/Link'
import { Modal } from 'components/Modal'
import { H5, Text } from 'components/Typography'
import { COLOR_INTENT, MODAL_MAX_WIDTH, SPACE } from 'Theme'

const MODAL_TITLE = 'WARNING For California Residents'
export interface Proposition65WarningModalProps {
  isOpen: boolean
  onModalClose: () => void
  chemical: string
}

export const Proposition65WarningModal: React.FC<
  React.PWC<Proposition65WarningModalProps>
> = ({ isOpen, onModalClose, chemical }) => {
  const isDefaultWarning = !chemical || chemical === 'null'

  return (
    <Modal
      ariaLabel={MODAL_TITLE}
      isOpen={isOpen}
      onModalClose={onModalClose}
      maxWidth={MODAL_MAX_WIDTH.PX_600}
      cancelButtonText="Close"
      customTitle={() => (
        <Flex>
          <Box mr={SPACE.PX_6}>
            <Icon.WarningProposition65
              color={COLOR_INTENT.PROPOSITION_65_MODAL.ICON}
            />
          </Box>
          <H5 mb={0}>{MODAL_TITLE}</H5>
        </Flex>
      )}
    >
      <Text>
        {isDefaultWarning ? (
          <>
            This product can expose you to chemicals which are known to the
            State of California to cause cancer and birth defects or other
            reproductive harm. For more information, go to{' '}
          </>
        ) : (
          <>
            This product can expose you to chemicals including {chemical}, which
            is known to the State of California to cause cancer and birth
            defects or other reproductive harm. For more information, go to{' '}
          </>
        )}
        <Link
          href="https://www.p65warnings.ca.gov"
          isExternal
          aria-label="p65 warnings"
        >
          www.p65warnings.ca.gov
        </Link>
        .
      </Text>
    </Modal>
  )
}
